import { Circle } from "lucide-react";
import { isFuture, isPast, isToday } from "date-fns";
import moment from "moment";
import ImageGeneric from "@/assets/images/lg.png";

export default function CardTarefa({
  tarefa,
  checkedTask,
  setTarefaSelecionada,
}: any) {
  function colorDate(data: any) {
    if (isToday(data)) {
      return "text-[#FFA100]";
    } else if (isPast(data)) {
      return "text-red-500";
    } else if (isFuture(data)) {
      return "text-azul-400";
    }
  }

  function getPriorityLabel(priority: any) {
    const statusConfig: any = {
      1: { label: "Alta", color: "bg-red-500" },
      2: { label: "Média", color: "bg-yellow-400" },
      3: { label: "Baixa", color: "bg-azul-400" },
    };
    return !!priority
      ? statusConfig[priority]
      : { label: "Sem prioridade", color: "bg-gray-400" };
  }

  return (
    <div
      key={tarefa?.id}
      className="bg-white sm:bg-cinza-100 px-4 py-2 rounded-[14px] relative flex flex-col gap-1"
    >
      <div className="flex justify-end items-end">
        <div
          className={`text-white text-xs px-2 py-1 rounded-full inline-flex items-center justify-center ${getPriorityLabel(tarefa?.priority)?.color}`}
        >
          <span>{getPriorityLabel(tarefa?.priority)?.label}</span>
        </div>
      </div>
      <div className=" flex flex-col gap-4">
        <div className="flex gap-2 items-center text-sm">
          <div>
            <p
              className={`font-medium capitalize cursor-pointer ${tarefa?.status === 2 && "line-through"}`}
              title={tarefa?.title}
              onClick={() => setTarefaSelecionada(tarefa)}
            >
              {tarefa?.title}
            </p>
            <div
              className="text-xs linkColor line-clamp-3 break-all"
              dangerouslySetInnerHTML={{
                __html: tarefa.description || "<p>Sem objetivo definido</p>",
              }}
            />
          </div>
        </div>
        <div>
          <p className="text-[10px] text-black/40">Responsável</p>
          <div className="inline-flex items-center bg-white rounded-full gap-2 w-full px-2 py-1">
            <img
              src={tarefa?.responsavel?.img ?? ImageGeneric}
              alt={tarefa?.responsavel?.name}
              className="w-5 h-5 object-cover rounded-full"
            />
            <p className="font-medium text-xs">
              {tarefa?.responsavel?.name} {tarefa?.responsavel?.last_name}
            </p>
          </div>
        </div>
        <div className="flex flex-col gap-2">
          <div
            className={`bg-cinza-100 sm:bg-white rounded-[14px] text-[10px] uppercase text-center md:px-8 py-1 ${colorDate(tarefa?.date)}`}
          >
            <p>
              <strong>
                {moment.utc(tarefa?.date).format("DD/MM/YYYY - HH:mm")}
              </strong>
            </p>
          </div>
          <div className="flex justify-end items-end gap-2">
            <p className="text-[10px]">Marcar como concluída</p>
            <button
              type="button"
              onClick={() => checkedTask(tarefa)}
            >
              {tarefa?.status === 1 && <Circle color="#153DCE" size={16} />}
              {tarefa?.status === 2 && (
                <Circle
                  size={16}
                  color="#153DCE"
                  fill={`${tarefa?.status === 2 && "#153DCE "}`}
                />
              )}
              {tarefa?.status === 3 && <Circle size={16} />}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
